// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LazyLoadImage-lazyLoadImageContainer-cxBtt {
    position: relative;
    height: 100%;
    width: 100%;
}

.LazyLoadImage-lazyLoadImagePreload-q7U0Y {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: var(--secondary-gray-bg);
}

.LazyLoadImage-lazyLoadImageLoaded-zQ7Cq {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 1;
    -webkit-transition: opacity 1s ease;
    transition: opacity 1s ease;
    background-color: var(--secondary-gray-bg) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/LazyLoadImage/LazyLoadImage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,4BAA4B;IAC5B,UAAU;IACV,mCAA2B;IAA3B,2BAA2B;IAC3B,qDAAqD;AACzD","sourcesContent":[".lazyLoadImageContainer {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n\n.lazyLoadImagePreload {\n    position: absolute;\n    z-index: 0;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-color: var(--secondary-gray-bg);\n}\n\n.lazyLoadImageLoaded {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-size: cover;\n    background-repeat: no-repeat;\n    opacity: 1;\n    transition: opacity 1s ease;\n    background-color: var(--secondary-gray-bg) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lazyLoadImageContainer": `LazyLoadImage-lazyLoadImageContainer-cxBtt`,
	"lazyLoadImagePreload": `LazyLoadImage-lazyLoadImagePreload-q7U0Y`,
	"lazyLoadImageLoaded": `LazyLoadImage-lazyLoadImageLoaded-zQ7Cq`
};
module.exports = ___CSS_LOADER_EXPORT___;
